<h3 class="ui primary header">
  {{ modal.context.title }}
  <i class="link times icon" (click)="modal.deny(undefined)"></i>
</h3>

<!-- <app-warning-label></app-warning-label> -->
<div class="ui label warning-label">
  <span>
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10 7.5V10.625M17.5 10C17.5 14.1421 14.1421 17.5 10 17.5C5.85786 17.5 2.5 14.1421 2.5 10C2.5 5.85786 5.85786 2.5 10 2.5C14.1421 2.5 17.5 5.85786 17.5 10ZM10 13.125H10.0063V13.1313H10V13.125Z"
        stroke="#2C6ECB"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  </span>

  <div class="text">
    <span>Please note:</span>
    Any changes made here will be verified before it appears on your profile
  </div>
</div>

<div class="content">
  <div
    class="scroll-wrapper ui basic segment"
    appPadding="0"
    [ngClass]="{ loading: pending }"
  >
    <div *ngIf="success || error" tamsyMargin marginY="10px">
      <esl-message-toast [(message)]="error"></esl-message-toast>
      <esl-message-toast
        [(message)]="success"
        [messageType]="'success'"
      ></esl-message-toast>
    </div>

    <div class="ui form" [formGroup]="otherTCCForm">
      <div
        style="
          font-weight: 600;
          font-size: 16px;
          line-height: 19px;
          color: #3f4395;
        "
      >
        Other Tax Identification Number
      </div>
      <div class="ui divider"></div>
      <div class="required field" [ngClass]="displayFieldCss('tccId')">
        <label>Tax Identification Number</label>
        <input
          #input
          formControlName="tccId"
          type="text"
          placeholder="Enter TCC ID/NO"
        />
        <app-field-error-display
          [displayError]="isFieldValid('tccId')"
          errorMsg="Please enter your TCC ID/NO"
        >
        </app-field-error-display>
      </div>

      <!-- <div class="required field" [ngClass]="displayFieldCss('issuedDate')">
        <label>Enter Issued Date</label>
        <input
                  suiDatepicker
                  [pickerMode]="mode"
                  placeholder="Enter your Issued Date"
                  type="text"
                  formControlName="issuedDate"
                />
        <app-field-error-display
          [displayError]="isFieldValid('issuedDate')"
          errorMsg="Please enter your issued date"
        >
        </app-field-error-display>
      </div>

      <div class="required field" [ngClass]="displayFieldCss('expiryDate')">
        <label>Enter Expiry Date</label>
        <input
                  suiDatepicker
                  [pickerMode]="mode"
                  placeholder="Enter Expiry Date"
                  type="text"
                  formControlName="expiryDate"
                />
        <app-field-error-display
          [displayError]="isFieldValid('expiryDate')"
          errorMsg="Please enter your Expiry Date"
        >
        </app-field-error-display>
      </div>

      <div class="required field" [ngClass]="displayFieldCss('taxOfficeName')">
        <label>Enter Tax Office Name</label>
        <input
          #input
          formControlName="taxOfficeName"
          type="text"
          placeholder="Enter Tax Office Name"
        />
        <app-field-error-display
          [displayError]="isFieldValid('taxOfficeName')"
          errorMsg="Please enter  your tax office name"
        >
        </app-field-error-display>
      </div>

      <div class="required field" [ngClass]="displayFieldCss('taxOfficeAddress')">
        <label>Enter Tax Office Address</label>
        <input
          #input
          formControlName="taxOfficeAddress"
          type="text"
          placeholder="enter Tax Office Address"
        />
        <app-field-error-display
          [displayError]="isFieldValid('taxOfficeAddress')"
          errorMsg="Please enter  your tax office address"
        >
        </app-field-error-display>
      </div>

      <div class="required field" [ngClass]="displayFieldCss('year')">
        <label>Enter Year</label>
        <input
                  suiDatepicker
                  [pickerMode]="'year'"
                  placeholder="Enter year"
                  type="text"
                  formControlName="year"
                />
        <app-field-error-display
          [displayError]="isFieldValid('year')"
          errorMsg="Please enter  year"
        >
        </app-field-error-display>
      </div>

      <div class="required field" [ngClass]="displayFieldCss('totalProfit')">
        <label>Total Profit</label>
        <input
          #input
          formControlName="totalProfit"
          type="text"
          placeholder="Enter total profit"
        />
        <app-field-error-display
          [displayError]="isFieldValid('totalProfit')"
          errorMsg="Please enter  total profit"
        >
        </app-field-error-display>
      </div>

      <div class="required field" [ngClass]="displayFieldCss('accessibleProfit')">
        <label>Accessible Profit</label>
        <input
          #input
          formControlName="accessibleProfit"
          type="text"
          placeholder="Enter Accessible Profit"
        />
        <app-field-error-display
          [displayError]="isFieldValid('accessibleProfit')"
          errorMsg="Please enter  Accessible Profit"
        >
        </app-field-error-display>
      </div>

      <div class="required field" [ngClass]="displayFieldCss('turnover')">
        <label>Turnover</label>
        <input
          #input
          formControlName="turnover"
          type="text"
          placeholder="Enter your turnover"
        />
        <app-field-error-display
          [displayError]="isFieldValid('turnover')"
          errorMsg="Please enter  your turnover"
        >
        </app-field-error-display>
      </div>

      <div class="required field" [ngClass]="displayFieldCss('taxPaid')">
        <label>Tax Paid</label>
        <input
          #input
          formControlName="taxPaid"
          type="text"
          placeholder="Enter tax paid"
        />
        <app-field-error-display
          [displayError]="isFieldValid('taxPaid')"
          errorMsg="Please enter  your tax paid"
        >
        </app-field-error-display>
      </div> -->

      <div appMargin marginB="7"></div>
    </div>

    <form
      class="ui form"
      [formGroup]="documentForm"
      appMargin
      style="margin-bottom: 30px"
    >
      <div fxLayout="row">
        <h2 class="ui head" fxFlex="auto">Upload Supporting Documents</h2>
        <button
          class="ui tiny icon button"
          fxLayoutAlign="end"
          style="border: none !important"
        >
          <i
            class="ui plus icon hoverable"
            suiPopup
            [popupInverted]="true"
            popupPlacement="bottom"
            popupText="upload Document"
            (click)="createDocument()"
          ></i>
        </button>
      </div>
      <div class="ui divider" appMargin marginT="1"></div>
      <div class="field" appMargin marginT="5px">
        <ng-container formArrayName="documents">
          <ng-container
            *ngFor="let docForm of documents.controls; let i = index"
          >
            <div
              fxLayout="row"
              fxLayoutGap="10px"
              fxLayoutAlign="start center"
              appMargin
              marginB="15px"
            >
              <div
                fxFlex="grow"
                class="ui segment"
                [formGroup]="docForm"
                style="border-radius: 8px"
              >
                <div
                  fxFlex="row"
                  fxLayoutGap="10px"
                  fxLayoutAlign="start center"
                  (click)="uploader.click()"
                >
                  <div fxFlex="50px" *ngIf="!fileNameArr[i]">
                    <div class="bordered-square"></div>
                  </div>
                  <div fxFlex="10" *ngIf="fileNameArr[i]">
                    <img src="assets/icons/file-type/doc-upload.svg" alt="" />
                  </div>
                  <div fxFlex="75">
                    <div class="upload-helpertext">
                      {{
                        fileNameArr[i] ? fileNameArr[i] : "Upload Document Here"
                      }}
                      <!-- <sui-progress
                        class="tiny primary"
                        appMargin
                        marginB="0"
                        [value]="doc.progress"
                        *ngIf="doc.progress > 0"
                      >
                      </sui-progress> -->
                    </div>
                  </div>
                  <div fxFlex fxLayoutAlign="end">
                    <input
                      #uploadDoc
                      type="file"
                      accept=".jpg, .jpeg, .png"
                      #uploader
                      (change)="onFileChange($event, i)"
                      placeholder="Browse for documents"
                      onclick="value = null"
                      style="display: none"
                    />
                    <div
                      class="ui button"
                      *ngIf="!fileNameArr[i]"
                      style="background-color: #eaeffb; border-radius: 8px"
                    >
                      Browse
                    </div>
                    <img
                      class="hoverable"
                      src="assets/icons/cancel.svg"
                      *ngIf="fileNameArr[i]"
                      (click)="removeDocSegment()"
                    />
                  </div>
                </div>
              </div>
              <!-- <i
                fxFlex="10px"
                class="ui cancel icon hoverable"
                (click)="removeDocSegment()"
              ></i> -->
            </div>
          </ng-container></ng-container
        >
      </div>
    </form>
  </div>
</div>

<div class="actions" style="background: inherit; border: none">
  <button class="ui basic primary button" (click)="modal.deny(undefined)">
    Back
  </button>
  <button
    class="ui primary button"
    [ngClass]="{ yellow: pending }"
    [disabled]="pending || !otherTCCForm.valid"
    (click)="updateDirector('UPDATE')"
    autofocus
  >
    Done
  </button>
</div>
